import React, { useState, useEffect, memo } from 'react';
import '../../css/Loader.css'; // Assuming the styles are moved into this CSS file
import loader from '../../assets/images/loader.svg';
import inmatelogo from '../../assets/images/inmate-logo.svg'
import TranslateFile from '../../Loc/TranslateFile';

const Loader = ({ isConvo = false , isinvite= false }) => {

    const currentLang = TranslateFile();

    return (
        <div className="d-flex justify-content-center align-items-center">
            {/* Loader Background */}
            <div className="col-bg"></div>

            {/* Main Loader */}
            {(isConvo || isinvite )?
                <div className="col-loader-data">
                    <span id="spnloaderMessage">{isinvite ? currentLang?.Sending_Invite : currentLang?.Sending_Message}</span>
                    <img src={loader} className="col-loader-data-2" alt="Loading..." />
                </div>
                :
                <div className="col-loader">
                    <img src={loader} alt="Loading..." className="col-loader-03" />
                    <img src={inmatelogo} alt="Inmate Logo" className="col-loader-image" />
                </div>
            }
        </div>
    );
};

export default memo(Loader);
